import { StateType } from '../index';

export const agreementsUserAgreementSelector = (state: StateType) => state.getIn(['agreements', 'agreements', 'user-agreement']);

export const agreementsIsFetching = (state: StateType) => state.getIn(['agreements', 'isFetching']);

export const agreementsIsFetchingState = (state: StateType) => state.getIn(['agreements', 'isFetchingState']);

export const isAgreementOpen = (state: StateType, id: string) => {
  const openAgreements = state.getIn(['agreements', 'openAgreements']);
  if (!openAgreements) {
    return false;
  }

  // @ts-ignore
  return openAgreements.includes(id);
};
